import { FacetAction } from "./facet-action";

class FacetSort extends HTMLElement {
    constructor() {
        super()

        this.bindEvents();
    }

    bindEvents() {
        this.addEventListener("click", this.onSortOptionSelect.bind(this))
    }

    onSortOptionSelect() {
        const facetAction = new FacetAction();
        const url = this.generateURLHash();

        facetAction.updateURLHash(url);
        facetAction.fetchPageContent(url);
    }

    generateURLHash() {
        const value = this.getAttribute("value") as string;
        let url = new URL(window.location.href);
        let params = new URLSearchParams(url.search);

        params.set('sort_by', value);
        url.search = params.toString();

        return url.href;
    }
}

customElements.define("facet-sort", FacetSort);